import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Sprite from '~components/Sprite'
import classNames from 'classnames'
import { graphql, StaticQuery } from 'gatsby'
import RichText from '~components/RichText'
import * as styles from '~styles/components/register.module.scss'
import * as editorStyles from '~styles/components/editor.module.scss'

const DOTDIGITAL_EMBED_ID = '50ZZ-7LK'

export default class Register extends Component {
  constructor () {
    super()
    this.form = React.createRef()
  }

  componentDidMount () {
    this.loadForm()
  }

  componentWillUnmount () {
    // Register is mounted/unmounted each time the modal opens. DotDigital's
    // embed.js tracks processed page IDs in a global window array and
    // silently refuses to re-open a form for an ID it's already seen, so
    // without this the form only ever loads on the first time the modal is
    // opened. Clearing our ID here lets the next mount register cleanly.
    if (window.__dmProcessedPages) {
      const index = window.__dmProcessedPages.indexOf(DOTDIGITAL_EMBED_ID)
      if (index > -1) window.__dmProcessedPages.splice(index, 1)
    }
  }

  loadForm () {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = `https://r1.dotdigital-pages.com/resources/sharing/embed.js?sharing=lp-embed&domain=r1.dotdigital-pages.com&id=${DOTDIGITAL_EMBED_ID}`
      this.form.current.appendChild(script)

      script.addEventListener('load', function () {
        const iframeElement = document.getElementById(DOTDIGITAL_EMBED_ID)
        iframeElement?.setAttribute('title', 'Sign up to our newsletter')
        resolve()
      })
    })
  }

  render () {
    return (
      <StaticQuery
        query={query} render={({ register }) => (
          <div className={classNames(styles.overlay)}>
            <section className={styles.modal}>
              <button className={styles.close} type="button" aria-label="Close" onClick={this.props.onClick}>
                <span className={styles.cross}>
                  <Sprite name="crossThin" fill={true} />
                </span>
              </button>

              <span className={classNames(styles.icon, 'icon')}>
                <Sprite name="envelope" />
              </span>

              <div className={classNames(styles.content, 'grid-x grid-small-center')}>
                <div className="cell smedium-8 medium-6">
                  <h3 className={styles.title}>
                    {register.title}
                  </h3>

                  {register.text && (
                    <div className={classNames(styles.text, editorStyles.editor)}>
                      <RichText json={JSON.parse(register.text.raw)} />
                    </div>
                  )}

                  <div className={styles.form} ref={this.form}></div>
                </div>
              </div>
            </section>
          </div>
        )}
      />
    )
  }
}

export const query = graphql`
  query {
    register: contentfulRegister(title: {regex: "/^(?!.*(sample))/gi"}) {
      title
      text {
        raw
      }
    }
  }
`

Register.propTypes = {
  onClick: PropTypes.func
}
